var correctCustomerCaptcha = (response) => {
    document.querySelector('[data-customer-captcha-verified]')?.setAttribute('data-customer-captcha-verified', response ? 1 : 0);
    toggleCustomerSubmitButton()
};

var correctEmployeeCaptcha = (response) => {
    document.querySelector('[data-employee-captcha-verified]')?.setAttribute('data-employee-captcha-verified', response ? 1 : 0);
    toggleEmployeeSubmitButton();
}

var wrongCustomerCaptcha = () => {
    document.querySelector('[data-customer-captcha-verified]')?.setAttribute('data-customer-captcha-verified', 0);
    toggleCustomerSubmitButton();
}

var wrongEmployeeCaptcha = () => {
    document.querySelector('[data-employee-captcha-verified]')?.setAttribute('data-employee-captcha-verified', 0);
    toggleEmployeeSubmitButton();
}

const toggleEmployeeSubmitButton = () => {
    let container = document.querySelector('.employee_request_form');
    let captchaVerified = container.closest('[data-employee-captcha-verified]')?.getAttribute('data-employee-captcha-verified');

    if (container.querySelector('[data-self-selector] .selected') && container.querySelector('[data-type-selector] .selected')) {
        document.querySelector('.employee_request_form [data-employee-submit]').classList.remove('disabled');
    }else{
        document.querySelector('.employee_request_form [data-employee-submit]').classList.add('disabled');
    }
    document.querySelectorAll('.employee_request_form .required_form input, .employee_request_form .required_form textarea, .employee_request_form .required_form select').forEach(ele => {
        if (!ele.value?.trim()) {
            document.querySelector('.employee_request_form [data-employee-submit]').classList.add('disabled');
        }
    })
}

const toggleCustomerSubmitButton = () => {
    let container = document.querySelector('.customer_request_form');
    let captchaVerified = container.closest('[data-customer-captcha-verified]')?.getAttribute('data-customer-captcha-verified');

    if (container.querySelector('[data-self-selector] .selected') && container.querySelector('[data-type-selector] .selected')) {
        document.querySelector('.customer_request_form [data-form-submit]').classList.remove('disabled');
    }else{
        document.querySelector('.customer_request_form [data-form-submit]').classList.add('disabled');
    }
    document.querySelectorAll('.customer_request_form .required_form input, .customer_request_form .required_form textarea').forEach(ele => {
        if (!ele.value?.trim()) {
            document.querySelector('.customer_request_form [data-form-submit]').classList.add('disabled');
        }
    })
}
window.addEventListener('DOMContentLoaded', (event) => {

    document.querySelectorAll('[data-modal-opener]').forEach(ele => {
        ele.addEventListener('click', event => {
            let modalId = event.target.closest('[data-modal-opener]').getAttribute('data-modal-opener');
            if (modalId === 'customer-delete-request-form') {
                if (Shopify && Shopify.CountryProvinceSelector) {
                    new Shopify.CountryProvinceSelector('shipping_country', 'shipping_province', {
                        hideElement: 'shippingProvinceContainer'
                    });
                }
            }
        })
    })

    document.querySelectorAll('[data-request-type-tabs] .request-style-tab').forEach(ele => {
        ele.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();

            let container = event.target.closest('[data-hero-section]');
            container.querySelector('.request-style-tab.active')?.classList?.remove('active');
            event.target?.classList?.add('active');
            let target = event.target.getAttribute('data-target');
            container.querySelector('.request_tab_content.active')?.classList?.remove('active');
            container.querySelector(`#${target}.request_tab_content`)?.classList?.add('active');
        })
    });

    document.querySelectorAll('.radio-button').forEach(ele => {
        ele.addEventListener('click', event => {
            let container = event.target.closest('.type-container');
            container.querySelector('.radio-button.selected')?.classList?.remove('selected');
            if (event.target.getAttribute('data-value')){
                event.target?.classList?.add('selected');
            }
            if (event.target.closest('.customer_request_form')) {
                toggleCustomerSubmitButton(event);
            } else {
                toggleEmployeeSubmitButton(event);
            }

            let target = event.target.getAttribute('data-value');
            let tabContainer = event.target.closest('.tabcontent');
            container.querySelector('[data-hidden-type]').value = target;

            tabContainer.querySelector('[data-request-details]')?.closest('.textarea-container')?.classList?.remove('d-none');
            document.querySelector('.type_toggle.active')?.classList?.remove('active');
            document.querySelector(`#${target}`)?.classList?.add('active');
        })
    });

    document.querySelectorAll('[data-request-details]').forEach(ele => {
        console.log(ele)
        ele.addEventListener("input", ({ currentTarget: target }) => {
            const maxLength = target.getAttribute("maxlength");
            const currentLength = target.value.length;

            if (currentLength >= maxLength) {
                return console.log("You have reached the maximum number of characters.");
            }

            target.closest('.textarea-container').querySelector('[data-counter] span').innerHTML = currentLength;
        });
    })
    
    document.querySelectorAll('.customer_request_form .required_form input, .customer_request_form .required_form textarea').forEach(ele => {
        ele.addEventListener('input', event => {
            if (event.target.value) {
                event.target.closest('.error')?.classList?.remove('error')
            } else {
                event.target.parentElement.classList.add('error');
                event.target.parentElement.querySelector("small").innerHTML = 'This field is required';
            }

            toggleCustomerSubmitButton(event);
        })
    })

    document.querySelectorAll('.employee_request_form .required_form input, .employee_request_form .required_form textarea, .employee_request_form .required_form select').forEach(ele => {
        ele.addEventListener('input', event => {
            if (event.target.value?.trim()) {
                event.target.closest('.error')?.classList?.remove('error')
            } else {
                event.target.parentElement.classList.add('error');
                event.target.parentElement.querySelector("small").innerHTML = 'This field is required';
            }
            toggleEmployeeSubmitButton(event);
        })
    })

    document.querySelector('.customer_request_form [data-country]').addEventListener('input', (event) => {
        let value = event.target.value;
        event.target.closest('select').setAttribute('value', value);
    })
});

if (window.location.href.includes('?contact_posted=true')) {
    document.querySelector('#customer-delete-request-success')?.show();

    document.querySelectorAll('#ModalClose-customer-delete-request-success').forEach((ele)=>{
        ele.addEventListener('click',()=>{
            history.pushState({}, '', `${window.location.pathname}`);
        })
    })
}
